module.exports = __webpack_public_path__ + "static/media/Artist.903455e6.jpg";